import axios from "../../../axios";

export function getSpecialProductList(payload: any) {
  let response = axios.post(`/products/special-list/`, payload);

  return response;
}
